'use client'

import { PasswordInputControl } from '@/components/CrudComponents/Forms/FormFields';
import {
  Button,
  Flex,
  Heading,
  Stack,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react'
import { useAction } from 'next-safe-action/hook';
import { useForm } from 'react-hook-form';
import { resetPassword } from './actions';
import { useRouter } from 'next/navigation';

interface ResetPasswordFormProps {
  resetPasswordToken: string;
}

export interface ResetPasswordSchema {
  newPassword: string;
  confirmNewPassword: string;
}

export default function ResetPasswordForm({ resetPasswordToken }: ResetPasswordFormProps) {

  const { handleSubmit, watch, reset, register, formState: { errors, isSubmitting } } = useForm<ResetPasswordSchema>()
  const toast = useToast()
  const router = useRouter()

  const { execute, status } = useAction(resetPassword, {
    onSuccess: (data) => {
      // console.log(data);

      if (data?.failure) {
        toast({
          title: 'Une erreur est survenue!',
          description: data?.failure.toString(),
          status: 'error',
          isClosable: true,
          position: 'top'
        })
      } else {
        toast({
          title: 'Opération réussie!',
          description: data?.success.toString(),
          status: 'success',
          isClosable: true,
          position: 'top'
        })

        router.push('/auth/signin')
      }
    },
    onError: (error) => {
      // console.log("Une erreur: ", error);

      toast({
        title: 'Error',
        description: 'Veuillez vérifier vos paramètres',
        status: 'error',
        isClosable: true,
        position: 'top'
      })
    }
  });

  async function onResetPassword(values: ResetPasswordSchema) {
    execute({ password: values?.newPassword, resetPasswordToken })
  }

  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bg={useColorModeValue('gray.100', 'gray.800')}>
      <Stack
        spacing={4}
        w={'full'}
        maxW={'xl'}
        bg={useColorModeValue('white', 'gray.700')}
        rounded={'xl'}
        boxShadow={'lg'}
        p={6}
        my={12}>
        <form onSubmit={handleSubmit(onResetPassword)}>
          <Heading mb={5} lineHeight={1.1} fontSize={{ base: '2xl', md: '3xl' }}>
            Entrer votre nouveau mot de passe
          </Heading>

          <PasswordInputControl
            field='newPassword'
            fieldFormat='New Password'
            validation={{
              required: 'Veuillez renseigner votre mot de passe',
              minLength: {
                value: 8,
                message: "Le mot de passe doit contenir au moins 8 charactères"
              }
            }}
            register={register}
            errors={errors}
          />
          <PasswordInputControl
            field='confirmNewPassword'
            fieldFormat='Confirm Password'
            validation={{
              required: 'Veuillez confirmer votre mot de passe',
              minLength: {
                value: 8,
                message: "Le mot de passe doit contenir au moins 8 charactères"
              },
              validate: (val: string) => {
                if (watch('newPassword') !== val) {
                  return "Les mots de passes ne correspondent pas."
                }
              }
            }}
            register={register}
            errors={errors}
          />

          <Stack spacing={6}>
            <Button
              type='submit'
              colorScheme='brand'
              isLoading={status && status === "executing"}
              >
              Envoyer
            </Button>
          </Stack>
        </form>
      </Stack>
    </Flex>
  )
}